import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const EmptyReviews = ({ children }) => {
  const ratings = [1, 2, 3, 4, 5];
  const starsList = ratings.map((value) => (
    <i key={value} className="fal fa-star" />
  ));

  return (
    <div
      className={styles.reviewsContainer}
      data-testid="rate-and-review-empty"
    >
      <div className={styles.starsContainer}>{starsList}</div>
      <h3 className={styles.title}>No Reviews Yet</h3>
      <p className={styles.subtitle}>Be the first to review this product.</p>
      {children}
    </div>
  );
};

EmptyReviews.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EmptyReviews;
